<script setup></script>

<template>
  <div class="bg-n-solid-2 outline outline-1 outline-n-weak rounded-xl p-4">
    <div class="flex gap-2 mb-3">
      <div
        class="w-10 h-10 rounded-full flex-shrink-0 bg-n-alpha-1 animate-loader-pulse"
      />
      <div class="flex-1 flex flex-col gap-1">
        <div class="h-3 rounded bg-n-alpha-1 animate-loader-pulse w-[85%]" />
        <div class="h-3 rounded bg-n-alpha-1 animate-loader-pulse w-[50%]" />
      </div>
    </div>

    <div class="flex flex-col gap-2 mb-3 pt-2 border-t border-n-weak">
      <div class="h-3 rounded bg-n-alpha-1 animate-loader-pulse w-[70%]" />
      <div class="h-3 rounded bg-n-alpha-1 animate-loader-pulse w-[50%]" />
    </div>

    <div class="flex gap-2">
      <div class="w-14 h-5 rounded-full bg-n-alpha-1 animate-loader-pulse" />
      <div class="w-14 h-5 rounded-full bg-n-alpha-1 animate-loader-pulse" />
    </div>
  </div>
</template>
